export enum IntegrationType {
  XERO = 'Xero',
}
